import { MyAccountPages, MyAccountPageTitles } from '@/app_lib/types/accounts/MyAccount';

// TODO: These things should probably becoming from our API instead
export const fortuneSocialLinks = [
  {
    href: 'https://www.facebook.com/FortuneMagazine/',
    id: 'facebook',
  },
  {
    href: 'https://twitter.com/FortuneMagazine/',
    id: 'twitter',
  },
  {
    href: 'https://www.linkedin.com/company/fortune-magazine/',
    id: 'linkedin',
  },
  {
    href: 'https://www.instagram.com/fortunemag/',
    id: 'instagram',
  },
  {
    href: 'https://www.pinterest.com/fortunemagazine/',
    id: 'pinterest',
  },
];

export const MyAccountLinks = [
  {
    href: '/account/my-profile/',
    id: MyAccountPages.Profile,
    label: MyAccountPageTitles[MyAccountPages.Profile],
  },
  {
    href: '/account/subscriptions/',
    id: MyAccountPages.Subscriptions,
    label: MyAccountPageTitles[MyAccountPages.Subscriptions],
  },
  {
    href: '/account/billing/',
    id: MyAccountPages.Billing,
    label: MyAccountPageTitles[MyAccountPages.Billing],
  },
  {
    href: '/my-account/newsletters/',
    id: MyAccountPages.Newsletters,
    label: MyAccountPageTitles[MyAccountPages.Newsletters],
  },
];

// For Binance Ticker
export const cryptoSectionSlugs = ['crypto', 'guide-hub', 'the-coins', 'companies', 'regulators', 'nfts-and-culture'];

export const noAdArticles = ['Personal Finance Evergreen', 'Health Evergreen'];
export const noInstreamAdArticles = ['No InStream Ads'];

export const placeholderFortuneImage = 'https://content.fortune.com/wp-content/uploads/2020/09/placeholder_16x9.jpg';
